module.exports = __webpack_public_path__ + "img/1-preview.c03a7263.jpg";